import React, { useState } from "react";
import PropTypes from "prop-types";

export default function Cost({ cost, onChange }) {
  const [isChecked, setIsCecked] = useState(cost != null ? true : false);

  function handleOnCheck() {
    setIsCecked(!isChecked);
  }

  return (
    <div className="cost">
        <input className="li-item" type="checkbox" checked={isChecked} onChange={handleOnCheck} />
        <label> Kostnad </label>
      {isChecked && (
        <div>
          <input
            type="text"
            name="cost"
            value={cost}
            className="cost-info"
            onChange={onChange}
          />
        </div>
      )
      }
    </div>
  );
}

Cost.propTypes = {
  cost: PropTypes.string,
  onChange: PropTypes.func.isRequired
};
